import { GetAccountUserListParameterType } from '../types/options';
import { AccountUserListResponseType } from '../types/accountUser';
import { IAccountUserListRepository } from '../repositories/AccountUserListRepository';

export interface IGetAccountUserListUsecase {
  invoke(options: GetAccountUserListParameterType): Promise<AccountUserListResponseType>;
}

export class GetAccountUserListUsecaseImpl implements IGetAccountUserListUsecase {
  constructor(private repository: IAccountUserListRepository) {
    this.repository = repository;
  }
  invoke(options: GetAccountUserListParameterType): Promise<AccountUserListResponseType> {
    return this.repository.getAccountUserList(options);
  }
}
